import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {IonicStorageModule} from "@ionic/storage-angular";
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { jwtInterceptorFn } from './core/interceptors/new.interceptor';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CacherService } from './services/cache/cacher.service';
import { SiteChromeComponent } from './components/site-chrome/site-chrome.component';
@NgModule({
  declarations: [AppComponent, SiteChromeComponent],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    IonicModule.forRoot({
      mode:"md"
    }),
    IonicStorageModule.forRoot({
      name:"speedoLive"
    }),
    AppRoutingModule,
    LazyLoadImageModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    InAppBrowser,
    provideHttpClient(withInterceptors([jwtInterceptorFn])),
    CacherService
  ],
  bootstrap: [AppComponent],
  exports:[]
})
export class AppModule {}
